import React from "react";
import { Route, Switch } from 'react-router-dom';  // Enables routing between the components
import ManageReports from 'components/EnsembleComponents/ReportsManagement/ManageReports';
import ManageDataExport from 'components/EnsembleComponents/ReportsManagement/DataExport/DataExportTabSystem';
import EventMarkerHome from "components/EnsembleComponents/ReportsManagement/EventMarker/EventMarkerHome";
import Dashboard2Home from "components/EnsembleComponents/ReportsManagement/Dashboard2/Dashboard2Home";
import DashboardHome from "components/EnsembleComponents/ReportsManagement/Dashboard/DashboardHome";

const ReportsSubRouting = ({ match }) =>  {
    return (
            <Switch>
               <Route path={'/ManageReports/ManageReportsDefinitions'} component={ManageReports}/>   
               <Route path={'/ManageReports/DataExport'} component={ManageDataExport}/>
               <Route path={'/ManageReports/EventMarker'} component={EventMarkerHome}/>
               <Route path={'/ManageReports/Dashboard'} component={DashboardHome}/>
               <Route path={'/ManageReports/Dashboard2'} component={Dashboard2Home}/>
            </Switch>
    );
}

export default ReportsSubRouting;